import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SpinnerGap } from '@phosphor-icons/react';

const PLATFORM_ROLES = ['super_admin', 'platform_admin', 'support_team', 'account_team', 'technical_team'];

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-center">
          <SpinnerGap className="h-8 w-8 animate-spin text-[#2D4A3E] mx-auto" />
          <p className="mt-2 text-[#595959]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0) {
    const userRoles = user.roles || [user.role];
    // Platform sub-roles inherit super_admin access
    const hasPlatformRole = userRoles.some(r => PLATFORM_ROLES.includes(r));
    const superAdminAllowed = allowedRoles.includes('super_admin');
    const directMatch = userRoles.some(r => allowedRoles.includes(r));

    if (!directMatch && !(superAdminAllowed && hasPlatformRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
